import { render, staticRenderFns } from "./varLine.vue?vue&type=template&id=a671bf5c&scoped=true"
import script from "./varLine.vue?vue&type=script&lang=js"
export * from "./varLine.vue?vue&type=script&lang=js"
import style0 from "./varLine.vue?vue&type=style&index=0&id=a671bf5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a671bf5c",
  null
  
)

export default component.exports